<div fxLayout>
  <main fxFlex [ngClass.lt-md]="{ mobile: true, subnav__exists: false }">
    <h2 fxLayout fxLayoutAlign="start center" fxLayoutGap="10px">
      <img class="clickable" [routerLink]="['../']" src="/assets/iconography/arrow-left-rose.svg" />
      <img fxHide.lt-md fxFlex="0 0 36px" height="36px" src="/assets/images/apps/mailchimp.png" />
      <span fxFlex>MailChimp</span>
      <button
        *ngIf="connected"
        type="submit"
        mat-flat-button
        class="button__small button__secondary"
        (click)="disconnect()">
        Disconnect
      </button>
    </h2>

    <sbnb-helptext-wrapper
      class="helptext-wrapper-type-content"
      [area]="'content'"
      [pageId]="'apps-mailchimp'"></sbnb-helptext-wrapper>

    <div fxLayout fxLayout.lt-md="column" fxLayoutGap="40px">
      <div fxFlex *ngIf="!loading">
        <h3>Details</h3>
        <button
          *ngIf="!connected"
          class="connect__button"
          [disabled]="false"
          type="submit"
          mat-flat-button
          (click)="connect()">
          Connect with MailChimp
          <mat-spinner *ngIf="false" class="button__spinner" diameter="30"></mat-spinner>
        </button>
        <div *ngIf="connected">
          <p *ngIf="meta && meta.account_name">
            Connected to MailChimp account: {{ meta.account_name }} ({{ meta.username }})
          </p>
          <p>Please select the list that will receive your guests' contacts.</p>
          <mat-form-field class="fw">
            <mat-select
              [(ngModel)]="selectedList"
              (ngModelChange)="updateSelectedList($event)"
              placeholder="Select a list">
              <mat-option *ngFor="let list of lists" [value]="list.id">
                {{ list.name }}
              </mat-option>
            </mat-select>
          </mat-form-field>
          <div fxLayout fxLayoutAlign="end center">
            <sbnb-save-indicator [saveStatus]="saveStatus"></sbnb-save-indicator>
          </div>
        </div>
      </div>
    </div>
  </main>
</div>
